import { useCommonActionFromDALV2 } from '@shares/actionFormDALV2';
import { useAsyncFn } from 'react-use';
import GetCheckUserAcceptedTermOfOrg from './api';

export type TUseGetCheckUserAcceptedTermOfOrg = {
  isLoading?: boolean;
  response?: {
    success: boolean;
    accepted: boolean;
  };
  handleSetOrgId: (orgId: string) => Promise<
    | {
        success: boolean;
        accepted: boolean;
      }
    | undefined
  >;
};

const useGetCheckUserAcceptedTermOfOrg = (): TUseGetCheckUserAcceptedTermOfOrg => {
  const commonActionFromDALV2 = useCommonActionFromDALV2();

  const [state, doFetch] = useAsyncFn(async (orgId: string) => {
    if (!orgId) return;
    const response: Promise<{
      success: boolean;
      accepted: boolean;
    }> = await commonActionFromDALV2(GetCheckUserAcceptedTermOfOrg, orgId);
    const result = await response;
    return result;
  }, []);

  return {
    handleSetOrgId: doFetch,
    response: state.value,
    isLoading: state?.loading,
  };
};

export default useGetCheckUserAcceptedTermOfOrg;
